<section class="block type-flex">
  <div class="col-filters filters">
    <header class="block-header">
      <h1 class="block-header-title">Projects</h1>
    </header>
    <!-- <tabs [active]="'detail-search'"></tabs> -->
    <app-filter-bar [aggregations]="aggregations" [filters]="filterBody" (filterChange)="filter()"></app-filter-bar>
  </div>

  <div class="col-results">
    <div class="filter-top-bar flex">
      <div class="search-form filter-search flex-1">
        <form action="search.html">
          <div class="search-wrapper">
            <input
              type="text"
              id=""
              name="q"
              [(ngModel)]="q"
              class="search-input"
              placeholder="What are you looking for?"
              (keyup)="keyUp($event)"
            />
            <button type="submit" class="search-button">
              <span class="icon is--left is--icon-search">
                <svg class="icon-svg">
                  <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                </svg>
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="teaser-group type-flex-3">
      <app-loader [loading]="$loadingResults | async"></app-loader>

      <ul class="teasers-group__list type-flex-3">
        <li class="item teaser-item" *ngFor="let d of details">
          <app-teaser-block [teaserItem]="d | teaserItem"></app-teaser-block>
        </li>
      </ul>
    </div>

    <app-pagination [currentPage]="currentPage" [amount]="settings.hits.total" [perPage]="size" [prefix]="'details'"></app-pagination>
  </div>
</section>
